query GetZoomIntegration {
    loggedInUser {
        id
        zoomIntegration {
            isEnabled
            email
        }
    }
}
